import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EyeStateTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EyeStateTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.5002 19.1886C5.83777 19.1886 2.70077 12.6 2.57062 12.32C2.47646 12.1169 2.47646 11.8842 2.57062 11.6821C2.70078 11.401 5.83777 4.81152 12.5002 4.81152C19.1627 4.81152 22.2992 11.401 22.4294 11.6821C22.5235 11.8842 22.5235 12.1169 22.4294 12.319C22.2992 12.6 19.1627 19.1886 12.5002 19.1886ZM4.11127 12.0005C4.79654 13.2429 7.58745 17.674 12.5002 17.674C17.4135 17.674 20.2035 13.2429 20.8892 12.0005C20.2035 10.7582 17.4135 6.32604 12.5002 6.32604C7.58695 6.32604 4.79654 10.7582 4.11127 12.0005Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5002 15.3017C10.6801 15.3017 9.19908 13.8207 9.19908 12.0005C9.19908 10.1804 10.6801 8.69937 12.5002 8.69937C14.3204 8.69937 15.8014 10.1804 15.8014 12.0005C15.8014 13.8207 14.3204 15.3017 12.5002 15.3017ZM12.5002 10.2139C11.5152 10.2139 10.7136 11.0155 10.7136 12.0005C10.7136 12.9856 11.5152 13.7872 12.5002 13.7872C13.4853 13.7872 14.2869 12.9856 14.2869 12.0005C14.2869 11.0155 13.4853 10.2139 12.5002 10.2139Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EyeStateTrueIcon;
